/* 布局 */
//前台
import Layout from "@views/layout";

const propertyspecoptionsRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "propertyspecoptions/list",
        name: "PROPERTYSPECOPTIONS",
        meta: {
            title: "资产规格值扩展",
            keepAlive:true
        },
        component: () => import("@views/business/propertyspecoptions/index.vue"),
    },
        ],
};

export default propertyspecoptionsRouter;
